import React from 'react';
import Footer from '../../../components/ui/Footer';

const FooterSection = () => <Footer />;

export default FooterSection;
